// Standalone SVG, one file per toast state. Uses currentColor so the SCSS
// (via --toast-accent) drives the colour — never hardcode a colour here.
const WarningIcon = ({ size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M10 3 L18 16.5 L2 16.5 Z" />
    <path d="M10 8.5 L10 12.5" />
    <circle cx="10" cy="15" r="0.7" fill="currentColor" stroke="none" />
  </svg>
)

export default WarningIcon
